import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_URL } from '../utils/constants';
export function CTASection() {
  return <section className="py-24 bg-grayDarkest relative overflow-hidden" data-id="element-50">
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-52">
          <h2 className="heading-brutalist text-4xl md:text-6xl mb-6 text-white" data-id="element-53">
            PROTEJA SUS DERECHOS HOY
          </h2>
          <p className="text-xl text-grayLightest mb-10 max-w-2xl mx-auto font-light" data-id="element-54">
            Agende una consulta confidencial y sin compromiso con nuestro equipo
            de expertos. El tiempo es un factor crítico en asuntos legales.
          </p>

          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-grayDarkest px-10 py-5 font-montserrat font-bold text-lg uppercase tracking-widest hover:bg-grayLightest hover:scale-105 transition-all duration-300 shadow-xl" data-id="element-55">
            protege tus DERECHOS HOY
          </a>
        </motion.div>
      </div>
    </section>;
}